/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_TargetInputs */

const en_pwf_target = /** @type {(inputs: Pwf_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to`)
};

const de_pwf_target = /** @type {(inputs: Pwf_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechseln zu`)
};

/**
* | output |
* | --- |
* | "Switch to" |
*
* @param {Pwf_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_target = /** @type {((inputs?: Pwf_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_target(inputs)
	return en_pwf_target(inputs)
});